import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { modals } from '@mantine/modals';
import { Text, Button } from '@mantine/core';
import { IconCheck, IconHelp, IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import TestsApi from "../../api/TestsApi";
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";
import ReactDOM from 'react-dom';

export function DiscardDraft({
  SelectedMemberWebsite,
  SelectedDraftThumbnail,
  SelectedDraftThumbnailChange,
  SelectedDraftPageId,
  SalesMarkTimeChange}:any) {

  const navigate = useNavigate();
  const discardDraftRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const discardDraftConfirm = (SelectedDraftThumbnail:any) => modals.openConfirmModal({
      trapFocus: false,
      title: 'Discard Draft',
      children: (
        <Text size="sm">
          Are you sure you want to discard the "Draft test"? <br/>
                  If you discard, all edits saved in the draft will be lost.
        </Text>
      ),
      labels: { confirm: 'Discard Draft', cancel: "Cancel" },
      confirmProps: { color: 'red' },
      onCancel: () => console.log('Cancel'),
        onConfirm: () => { 
        handleDiscarddraft(SelectedDraftThumbnail);
      }
  });

  const handleDiscarddraft = (SelectedDraftThumbnail:any) => {
    TestsApi.discarddraft({
      system_website_id: SelectedMemberWebsite,
      page_id:SelectedDraftPageId,
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        SelectedDraftThumbnailChange(null);
        SalesMarkTimeChange(data.data.updated_time);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (discardDraftRef.current) {
      const { top, left, width } = discardDraftRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset - 160,
        left: left + width + 10, 
      });
    }
  };

  return (
    <>
      {showHelpModal &&
      ReactDOM.createPortal(
        <div style={{ zIndex: 9999 }}>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition}
          />
        </div>,
        document.body
      )}
      <Button
        type="button"
        style={{ marginLeft: 7, backgroundColor: '#ff8125' }}
        onClick={() => discardDraftConfirm(SelectedDraftThumbnail)}
      >
      Discard Draft test
      </Button>
      <IconHelp ref={discardDraftRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer', marginLeft:3}} onClick={() => handleHelpClick(328)}/>
    </>
  );
}